import SBEditable from "../../../components/sbEditable/sbEditable";
import ListingHeader from "../../../components/listingHeader/listingHeader";
import Grid from "../../../components/grid/grid";

import GetComponentsFromBloks from "../../../helpers/bloksRenderer";

import styles from "./gridPanel.module.scss";

/// Blok:gridPanel
// gridpanel:blok
///
/// header:string
/// items:bloks
/// header_underline_color:string ('backgroundcolor-crorange' or 'backgroundcolor-crscooter')
/// desktop_columns:number
/// tablet_columns:number
/// mobile_columns:number
/// grid_flow_direction:string ('horizontal' or 'vertical')
/// horizontalLineColorInLightMode:string ('scooter' or 'default') 
/// hideUnderlineSingleColumn:boolean
function GridPanel({ blok }) {
  const gridItems = GetComponentsFromBloks(blok.items);

  return (
    <SBEditable blok={blok} withId={blok.anchor}>
      <div className={styles.root}>
          {blok.header ? (
            <ListingHeader underlineColor={blok.header_underline_color}>
              <h2>{blok.header}</h2>
            </ListingHeader>
          ) : null}
        <Grid
          gridItems={gridItems}
          desktopColumns={blok.desktop_columns}
          tabletColumns={blok.tablet_columns}
          mobileColumns={blok.mobile_columns}
          gridFlowDirection={blok.grid_flow_direction}
          horizontalLineColorInLightMode={blok.horizontal_line_color_light_mode}
          hideUnderlineSingleColumn={blok.hide_underline_single_column}
        />
      </div>
    </SBEditable>
  );
}

export default GridPanel;
